import React, { useMemo, useState, useEffect } from "react";
// MUI
import MuiButton from "@mui/material/Button";
import makeStyles from "@mui/styles/makeStyles";
import { CSSProperties } from "@mui/styles";

// Icon
import SearchIcon from "@mui/icons-material/Search";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import { useHistory, useLocation } from "react-router";
import { FormattedMessage, useIntl } from "react-intl";

// UX
import CardCenterGroupList from "./CardCenterGroupList";
import TopServices, { TOP_SERVICES } from "./TopServices";
// appointment
import SearchBox from "../appointment/SearchBox";
// patient-lib
import BottomSheetSelectHospital from "patient-lib/BottomSheetSelectHospital";
// medication
import HeaderBar from "bplus-lib/medication/HeaderBar";

// Interface
import { Event, State } from "../MobSmartAppointmentInterface";

// Const.
import { URLS } from "./Constants";
import CONFIG from "config/config";

// Types
type DoctorAppointmentProps = {
  onEvent: (e: Event) => any;
  setProp: (key: string, value: any, callback?: Function) => any;
  // data
  hospitalList?: any[];
  // config
  simulator?: boolean;
} & Pick<
  State,
  | "topServiceList"
  | "loadingStatus"
  | "centerGroupList"
  | "language"
  | "selectedHospital"
>;

type DALocationType = {
  routes?: any;
  storedState?: {
    hospital?: Record<string, any> | null;
  };
};

// Styles
const COLORS = {
  btn_gradient: "linear-gradient(180deg, #0147A3 0%, #0B87CD 100%)",
  bg_gradient: "linear-gradient(147.46deg, #0669EB 0%, #00357A 71.53%)",
  bg_opacity: "rgba(255, 255, 255, 0.12)",
};

const selectHospitalStyles = {
  "&.MuiButton-root": {
    backgroundColor: COLORS.bg_opacity,
    boxShadow: "none",
    borderRadius: "8px",
    color: "white",
    padding: "0.85rem .5rem 0.85rem 1rem",
    width: "100%",
    justifyContent: "flex-start",
    textTransform: "unset",
    margin: "14px 0 0",
    "& svg": {
      fontSize: "2rem",
    },
    "&:hover": {
      backgroundColor: COLORS.bg_opacity,
      boxShadow: "none",
    },
  },
} as CSSProperties;

const useStyles = makeStyles((theme) => ({
  screen: {
    background: "white",
    minHeight: "100vh",
    width: "100%",
    position: "relative",
  },
  search_box: {
    "& svg": {
      color: "white",
    },
    "& input": {
      paddingLeft: "1em !important",
      background: "white !important",
    },
    "& .search.icon": {
      display: "none",
    },
  },
  header_inner: {
    padding: "15px 15px 37px",
    background: COLORS.bg_gradient,
    marginTop: "-50px",
    paddingTop: "50px",
  },
  select_hospital: selectHospitalStyles,
  content: {
    borderTopLeftRadius: "16px",
    borderTopRightRadius: "16px",
    marginTop: "-16px",
    background: "white",
    width: "100%",
    height: "17px",
    padding: "22px 16px",
  },
  title: {
    fontSize: "1.125rem",
    fontWeight: "bold",
    marginBottom: "0.25rem",
  },
}));

const BUTTON_ACTIONS = {
  centergroup: "_CENTER_GROUP",
};

const DOCTOR_APPOINTMENT = "DoctorAppointment";
const ACTION_CENTERGROUP = `${DOCTOR_APPOINTMENT}${BUTTON_ACTIONS.centergroup}`;

const DoctorAppointment = (props: DoctorAppointmentProps) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation<DALocationType>();
  const intl = useIntl();

  const params = new URLSearchParams(window.location.search);
  const app = params.get("app");

  const MOB_APP = `app=${app}`;
  const backToMain = params.get("backToMain");

  const [openModSelectHospital, setOpenModSelectHospital] =
    useState<boolean>(false);
  const [selectedHospital, setSelectedHospital] = useState<Record<
    string,
    any
  > | null>(null);
  const [showTopService, setShowTopService] = useState<boolean>(false);

  // Memo Effect
  const locState = useMemo(() => {
    return location.state || {};
  }, [location.state]);

  const createMobHospital = (code: string, name: "") => {
    return {
      code: code,
      id: code,
      name:
        props.language === "th-TH"
          ? "โรงพยาบาลกรุงเทพ สำนักงานใหญ่"
          : "Bangkok Hospital Headquarters",
    };
  };

  const hospitalItems = useMemo(() => {
    const list = props.hospitalList || [];
    var finalList = [];

    if (list.length === 0) {
      finalList = CONFIG.ENABLE_HOSPITAL_APPOINTMENT.map((item) => {
        return createMobHospital(item, "");
      });
    } else if (list.length === 1 && list[0].code === "1") {
      finalList = list;
    } else {
      finalList = [
        {
          code: "-1",
          name:
            props.language === "th-TH"
              ? "เครือข่ายโรงพยาบาลกรุงเทพทั้งหมด"
              : "All Bangkok Hospital",
        },
        ...list,
      ];
    }

    return finalList;
  }, [props.hospitalList]);

  // Effect
  useEffect(() => {
    let selectHos = hospitalItems[0];
    if (props.selectedHospital) {
      selectHos = hospitalItems.find(
        (item: any) => item.code === props.selectedHospital.code
      );
    }
    setSelectedHospital(
      locState.storedState?.hospital || selectHos || hospitalItems[0]
    );
  }, [locState.storedState,props.selectedHospital]);

  useEffect(() => {
    if (selectedHospital?.code) {
      props.onEvent({
        message: "GetListCenterGroup",
        params: {
          lang: intl.locale,
          card: ACTION_CENTERGROUP,
          hospital: selectedHospital?.code,
        },
      });
    }
  }, [selectedHospital]);

  // Memo
  const filterCenterGroup = useMemo(() => {
    const lists = props.centerGroupList || [];
    return lists;
    // return !selectedHospital?.code
    //   ? lists
    //   : lists.filter((item) => selectedHospital.code === item.hospital_code);
  }, [props.centerGroupList, selectedHospital]);

  // Handler
  const handleOpenModSelectHospital = () => {
    setOpenModSelectHospital(true);
  };

  const handleSearchDoctor = () => {
    handleHistoryPushState({
      pathname: URLS.SEARCH_DOCTOR,
    });
  };

  const handleSelectCenterGroup = (selected: Record<string, any>) => {
    handleHistoryPushState({
      pathname: URLS.SELECT_CENTER,
      centergroup: selected,
    });
  };

  const handleSelectTopService = (selected: Record<string, any>) => {
    if (selected.type === "med_program") {
      handleHistoryPushState({
        pathname: URLS.SELECT_CHECKUP_TYPE,
        centergroup: { ...selected, appointment_type: "check_up" },
      });
    }
  };

  const handleHistoryPushState = async (data: any) => {
    await props.setProp("textSearch", "");

    props.onEvent({
      message: "HandleHistoryPushState",
      params: {
        pathname: data.pathname,
        history: history,
        state: {
          centergroup: data?.centergroup,
          hospital: selectedHospital?.code ? selectedHospital : null,
        },
      },
    });
  };

  const handleCheckGoBack = () => {
    history.replace(`/?${MOB_APP}`);
  };

  return (
    <div
      className="remember-scroll"
      style={{ height: "100vh", overflowY: "auto" }}
    >
      <HeaderBar
        setTitle={intl.formatMessage({ id: "bplusClinicKey1218" })}
        headerSx={{
          background: `linear-gradient(147.46deg, #0669EB 0%, #00357A ${
            showTopService ? 145 : 106
          }%) !important`,
        }}
        titleStyle={{ fontWeight: "bold", fontSize: "1.1rem" }}
        // config
        hiddenRight={true}
        hiddenLeft={true}
        buttonLeftback={true}
        onGoBack={backToMain === "true" ? handleCheckGoBack : undefined}
      />
      <div className={classes.screen}>
        <div className={classes.header_inner}>
          <SearchBox
            className={classes.search_box}
            placeholder={intl.formatMessage({ id: "bplusClinicKey1224" })}
            hideSearchList={true}
            // style
            rightIconColor={COLORS.btn_gradient}
            // callback
            onInputClick={handleSearchDoctor}
            onRightIconClick={handleSearchDoctor}
            // Element
            rightIcon={<SearchIcon />}
          />

          <MuiButton
            className={classes.select_hospital}
            variant="contained"
            onClick={handleOpenModSelectHospital}
          >
            <span>{selectedHospital?.name}</span>
            <div style={{ flex: 1 }}></div>
            <ArrowDropDownIcon />
          </MuiButton>

          <TopServices
            onEvent={props.onEvent}
            // data
            hospitalCode={selectedHospital?.code}
            topServiceList={props.topServiceList}
            loading={props.loadingStatus?.[TOP_SERVICES]}
            isRefresh={true}
            // config
            simulator={props.simulator}
            // callback
            onShowTopService={setShowTopService}
            onSelect={handleSelectTopService}
          />
        </div>

        <div className={classes.content}>
          <div className={classes.title}>
            <FormattedMessage id={"bplusClinicKey1225"} />
          </div>

          <div style={{ paddingBottom: "1rem" }}>
            <CardCenterGroupList
              items={filterCenterGroup}
              loading={props.loadingStatus?.[ACTION_CENTERGROUP]}
              noResultsMessage={
                <>
                  <div>
                    ไม่พบ Center group สำหรับ
                    <div>
                      <span>“{selectedHospital?.name}”</span>
                    </div>
                  </div>
                  <div>กรุณาเลือกโรงพยาบาลใหม่</div>
                </>
              }
              // callback
              onSelect={handleSelectCenterGroup}
            />
          </div>
        </div>

        <BottomSheetSelectHospital
          open={openModSelectHospital}
          hospitalList={hospitalItems}
          selectedHospital={selectedHospital}
          onChange={setOpenModSelectHospital}
          onSelect={setSelectedHospital}
        />
      </div>
    </div>
  );
};

export default React.memo(DoctorAppointment);
